/** Stable order: existing immutable-ID hashes map to the same profile character everywhere. */
export const agentCharacterIds = [
  "nova",
  "atlas",
  "milo",
  "alma",
  "cleo",
  "vega",
  "otis",
  "iris",
] as const

export type AgentCharacterId = (typeof agentCharacterIds)[number]

/** The profile choice controls appearance; the separate moon continues to show runtime state. */
export const agentCharacterSignatures = {
  nova: "orb",
  atlas: "diamond",
  milo: "petal",
  alma: "star",
  cleo: "sun",
  vega: "hexagon",
  otis: "capsule",
  iris: "crescent",
} as const satisfies Record<AgentCharacterId, string>

export type AgentSignature = (typeof agentCharacterSignatures)[AgentCharacterId]
